import React from 'react';
import moment from 'moment';
import CommonModal from './Modal';
import ReactDropDownCalender from '../../../components/ReactDropDownCalender';
import LocalStorageService from '../../../services/utilities/LocalStorageService';
import { messageUtility } from '../../../utilities/messageUtility';
import { isPartnerCompanyRoleId } from '../../../utilities/roleUtility';

/**
 * @description 予定コピーダイアログ
 *              ゲート、揚重機、機材予定一覧画面で使用
 * @param {boolean} visible true: 表示, false, 非表示
 * @param {string} setKey 日付キー
 * @param {string} targetDate 日付
 * @param {function} callbacks 予定コピーメソッド
 */
const CopyPlan = props => {
  const { visible, setKey, targetDate, callbacks } = props;

  const isAvailable = () => {
    const roleId = LocalStorageService.getRoleId();
    if (!isPartnerCompanyRoleId(roleId)) {
      return true;
    }
    return !moment(targetDate).isBefore(moment().format('YYYY/MM/DD'));
  };

  const styles = {
    content: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    label: {
      marginRight: 16,
    },
    btn: {
      display: 'inline-block',
    },
  };

  return (
    <React.Fragment>
      {visible && (
        <CommonModal visible={visible}>
          <div id='modal-dialog-copy' className='modal show'>
            <div className='dialog-md dialog--modal'>
              <div className='dialog-md__header'>
                <span className='dialog-md__title'>コピー先の日付を選択</span>
              </div>
              <div className='dialog-md__body'>
                <div style={styles.content}>
                  <span className='label' style={styles.label}>
                    期間
                  </span>
                  <div className='form-list__element'>
                    <ReactDropDownCalender
                      value={targetDate}
                      onChange={date => callbacks.calender(setKey, date)}
                    />
                  </div>
                </div>
                <div
                  style={
                    isAvailable()
                      ? { display: 'none' }
                      : { display: 'block', color: '#E64E17', fontSize: '12px' }
                  }
                >
                  {messageUtility.getMessage('I-001-309')}
                </div>
              </div>
              <div className='dialog-md__footer-horizontal'>
                <button
                  id='modal-close-copy'
                  className='btn--sub'
                  onClick={() => callbacks.handleVisible('copy')}
                  style={styles.btn}
                >
                  戻る
                </button>
                <button
                  id='modal-submit-copy'
                  className='btn--effective'
                  style={isAvailable() ? styles.btn : { display: 'none' }}
                  onClick={callbacks.copy}
                >
                  コピーして追加
                </button>
              </div>
            </div>
          </div>
        </CommonModal>
      )}
    </React.Fragment>
  );
};

export default CopyPlan;



// WEBPACK FOOTER //
// ./src/components/modals/common/CopyPlan.jsx